import styled from 'styled-components';

export const FiltersContainers = styled.div`
  display:flex;
  flex-direction: row;
  gap: 15px;
`;
